import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCSzhqsUFWPqQ4Gdw_kKSMzxiSoSCtqe_Y",
    authDomain: "shoppinglist-117ae.firebaseapp.com",
    projectId: "shoppinglist-117ae",
    storageBucket: "shoppinglist-117ae.appspot.com",
    messagingSenderId: "479057738851",
    appId: "1:479057738851:web:ad0fed4fc7c50516a68c56"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const db = firebase.firestore();

firebase.auth().onAuthStateChanged(function(user) {
    console.log('auth state changed');
    if (user) {
        db.collection('users').doc(user.uid).get().then((docSnapshot) => {
            if (!docSnapshot.exists) {
                console.log(user.uid);
                db.collection('users').doc(user.uid).set({ });
            }
        });
    }
});